export default "__VITE_ASSET__BN4TSLoP__"